export default {
  subTitle: 'Settings',
  pageTitle: 'Point & discount codes',
}